import React, { useMemo, useState } from 'react';

const TIPOS = ['Parcial', 'Final', 'Entrega de TP', 'Exposición', 'Otro'];
const DURACIONES = [60, 90, 120];

export default function EventoForm({ onSubmit, materiasSugeridas = [], defaultDate }) {
  const [materia, setMateria] = useState('');
  const [tipo, setTipo] = useState('Parcial');
  const [fecha, setFecha] = useState(() => {
    const d = defaultDate || new Date();
    const iso = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString();
    return iso.slice(0, 16);
  });
  const [fin, setFin] = useState('');
  const [duracion, setDuracion] = useState(60);
  const [showAvanzado, setShowAvanzado] = useState(false);
  const [descripcion, setDescripcion] = useState('');

  const opciones = useMemo(() => {
    const q = materia.toLowerCase();
    return materiasSugeridas.filter((m) => m.toLowerCase().includes(q)).slice(0, 8);
  }, [materia, materiasSugeridas]);

  function handleSubmit(e) {
    e.preventDefault();
    if (!fecha) return;
    const startISO = new Date(fecha).toISOString();
    const endISO = fin ? new Date(fin).toISOString() : undefined; // el padre calculará fin por tipo si no se provee
    onSubmit?.({
      id: crypto.randomUUID?.() || String(Date.now()),
      tipo,
      materia: materia || undefined,
      descripcion: descripcion || undefined,
      start: startISO,
      end: endISO,
    });
    setMateria('');
    setDescripcion('');
  }

  return (
    <form onSubmit={handleSubmit} className="card">
      <div className="card-title">➕ Evento Único</div>
      <div className="field">
        <label htmlFor="evento-materia">Materia</label>
        <input
          id="evento-materia"
          type="text"
          value={materia}
          onChange={(e) => setMateria(e.target.value)}
          list="materias-list"
          placeholder="Ej: Derecho Civil I"
        />
        <datalist id="materias-list">
          {opciones.map((m) => (
            <option key={m} value={m} />
          ))}
        </datalist>
      </div>
      <div className="field">
        <label htmlFor="evento-tipo">Tipo</label>
        <select id="evento-tipo" value={tipo} onChange={(e) => setTipo(e.target.value)}>
          {TIPOS.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>
      <div className="field">
        <label htmlFor="evento-fecha">Fecha y hora inicio</label>
        <input id="evento-fecha" type="datetime-local" value={fecha} onChange={(e) => setFecha(e.target.value)} />
      </div>
      <div className="field">
        <button type="button" className="icon-btn" aria-expanded={showAvanzado} aria-controls="evento-avanzado" onClick={() => setShowAvanzado(v => !v)}>⚙️ Avanzado</button>
        {showAvanzado && (
          <div id="evento-avanzado" style={{ display: 'grid', gap: 8 }}>
            <label htmlFor="evento-duracion">Duración (min)</label>
            <select id="evento-duracion" value={duracion} onChange={(e) => setDuracion(parseInt(e.target.value, 10))}>
              {DURACIONES.map((d) => (
                <option key={d} value={d}>{d}</option>
              ))}
            </select>
            <label htmlFor="evento-fin">Fecha y hora fin (opcional)</label>
            <input id="evento-fin" type="datetime-local" value={fin} onChange={(e) => setFin(e.target.value)} />
            <small>Si no se indica fin: render 90min por defecto y export ICS con 90min.</small>
          </div>
        )}
      </div>
      <div className="field">
        <label htmlFor="evento-desc">Descripción (opcional)</label>
        <textarea id="evento-desc" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} rows={2} />
      </div>
      <div className="actions">
        <button className="btn-primary" type="submit" aria-label="Agregar evento">Agregar</button>
      </div>
    </form>
  );
}


